<template>
  <IntegrationBox>
    <button v-on:click="handleClose" class="close">X</button>
    <div class="box">

      <div class="mb-30">
        <img v-if="type" :src="getSvgStoreUrl(`${type}`)" height="35" :alt="type" />
        <br />
        <b class="mt-0">{{type}}</b>
      </div>

      <div class="fields" v-if="mountInputs && mountInputs.length > 0">
        <div v-for="input in mountInputs" :key="input.title">
          <Fieldinput v-if="input.type === 'text'" :data="input" />
          <FieldSelect v-if="input.type === 'select'" :data="input" :onChange="(input.onChange) ? input.onChange : null" />
        </div>
      </div>
      <div class="fields" v-else>
        <p>Sem dados da integração.</p>
      </div>

    </div>
  </IntegrationBox>
</template>

<script>
import { mapState } from "vuex";
import Fieldinput from "@/components/fields/Fieldinput.vue";
import FieldSelect from "@/components/fields/FieldSelect.vue";
import IntegrationBox from "@/components/integration-box/Integrationbox.vue";
import { getSvgStoreUrl } from "../../utils/url";
import { getGoogleAdsAccounts, selectGoogleAdsAccount } from "../../api/integrations";

export default {
  props: [
    "edit",
    "integrations",
  ],
  components: {
    IntegrationBox,
    Fieldinput,
    FieldSelect,
  },
  data() {
    return {
      inputs: [],
      inputsValues: {},
      type: null,
      integration: null,
      inputVtexLegacy: [
        {
          title: "Accountname",
          type: "text",
          name: "accountname",
          value: "",
          readonly: true,
        },
        {
          title: "App Key",
          type: "text",
          name: "vtexappkey",
          value: "",
          readonly: true,
        },
        {
          title: "App Token",
          type: "password",
          name: "vtexapptoken",
          value: "",
          readonly: true,
        }
      ],
      inputNuvemshopShopify: [
        {
          title: "ID Loja",
          type: "text",
          name: "storeid",
          value: "",
          readonly: true,
        },
        {
          title: "Nome da Loja",
          type: "text",
          name: "store_name",
          value: "",
          readonly: true,
        },
        {
          title: "URL da Loja",
          type: "text",
          name: "store_url",
          value: "",
          readonly: true,
        }
      ],
      inputVtexIo: [
        {
          title: "Accountname",
          type: "text",
          name: "accountname",
          value: "",
          readonly: true,
        },
      ],
      inputGoogleAds: [
        {
          title: "ID da Conta",
          type: "text",
          name: "selected_customer_id",
          value: "",
          readonly: true,
        },
        {
          title: "Nome da Conta",
          type: "text",
          name: "selected_customer_name",
          value: "",
          readonly: true,
        },
        {
          title: "Status",
          type: "text",
          name: "status",
          value: "",
          readonly: true,
        },
      ],
    }
  },
  mounted() {
    this.fillData();
  },
  methods: {
    getGoogleAdsAccounts,
    getSvgStoreUrl,
    async fillData() {
      let integration = this.integrations.filter(obj => obj.id === this.edit);
      this.integration = (integration.length > 0) ? integration[0] : null;
      this.type = (this.integration != null) ? this.integration.type : null;
      // console.log('this.integration',  this.integration);
      switch (this.type) {
        case 'vtexlegacy':
          this.inputs = this.inputVtexLegacy;
          this.inputsValues = this.integration.vtex_legacy;
          break;

        case 'nuvemshop':
          this.inputs = this.inputNuvemshopShopify;
          this.inputsValues = this.integration.nuvemshop;
          break;

        case 'shopify':
          this.inputs = this.inputNuvemshopShopify;
          this.inputsValues = this.integration.shopify;
          break;

        case 'vtexio':
          this.inputs = this.inputVtexIo;
          this.inputsValues = this.integration.vtex_io;
          break;

        case 'googleads':
          if (!this.integration.google_ads.selected_customer_id) {
            this.getGoogleAdsAccounts();
          } else {
            this.inputs = this.inputGoogleAds;
            this.inputsValues = this.integration.google_ads;
          }
          break;

        default: break;
      }
    },
    getIndex(type) {
      return this.inputs.findIndex(input => input.name === type);
    },
    handleClose() {
      this.$emit("closeAddIntegration", false);
    },
  },
  computed: {
    ...mapState({
      googleAdsAccounts: state => state.integrations.googleAdsAccounts,
    }),
    mountInputs() {
      let inputs = this.inputs;
      if (!inputs || inputs.length === 0) return;

      if (this.inputsValues != null) {
        inputs.forEach(input => {
          input.value = this.inputsValues[input.name];
        });
      } else {
        inputs = [];
      }

      return inputs;
    },
  },
  watch: {
    googleAdsAccounts(accounts) {
      if (!accounts || !accounts.selected_customer_id) {

        const options = accounts.accounts.filter(acc => acc.selectable === true).map((acc) => {
          return {
            label: `${acc.name} (${acc.customer_id})`,
            value: acc.customer_id
          }
        });

        console.log('accounts options', options);

        this.inputs = [
          {
            title: "Conta de anúncios",
            type: "select",
            name: "selected_customer_id",
            value: "",
            readonly: true,
            options: [
              { label: "Selecione a conta", value: ""},
              ...options
            ],
            onChange: (v) => {
              console.log('change value', v)
              selectGoogleAdsAccount(v);
              this.handleClose();
            }
          }
        ];
      } else {
        this.inputs = this.inputGoogleAds;
      }
      console.log('this.inputs', this.inputs);
    }
  }
};
</script>

<style lang="scss" scoped>
.close {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: transparent;
  border: none;
}
.integration {
  .box {
    flex: 1;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;

    form {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      button {
        max-width: 335px;
        width: 100%;
        height: 51px;
        border-radius: 5px;
        background-color: #41a7ff;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        font-family: $font__main;
        border: none;
      }
    }

    .init-button {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 335px;
      width: 100%;
      height: 51px;
      border-radius: 5px;
      background-color: #73cb53;

      a {
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        font-family: $font__main;
      }
    }

    .delete-button {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 335px;
      width: 100%;
      height: 51px;
      border-radius: 5px;
      background-color: #ffffff;
      border: 1px solid;
      border-color: #000000;
      cursor: pointer;

      a {
        color: #ff0000;
        font-size: 16px;
        font-weight: bold;
        font-family: $font__main;
      }
    }
  }
}

@media only screen and (max-width: 1400px) {
}

@media only screen and (max-width: 700px) {
}
</style>
